import { StateCreator } from "zustand"
import toast from "react-hot-toast"

import * as UsersTypes from "@pages/Users/Users.types"
import * as StoreTypes from "@src/types/store"

import { apiService } from "@src/services/apiService"

const initState = {
  users: [],
  paginationUsers: null,
  userQueryParams: {
    role: UsersTypes.UserRole.USER,
    per_page: 20,
    page: 1,
  },
}

export const createUsersSlice: StateCreator<StoreTypes.StoreState, [], [], StoreTypes.UsersSlice> = (
  set,
  get,
) => ({
  ...initState,
  getUsers: async (params: Partial<UsersTypes.IQueryParams> = {}) => {
    const { userQueryParams, loading } = get()
    if (loading === "FETCHING_USERS") return
    try {
      set({ loading: "FETCHING_USERS" })
      const response = await apiService.users.getCollection({ ...userQueryParams, ...params })
      const { data, pagination, status } = response.data as UsersTypes.UsersResponse
      if (!status) {
        throw new Error("Error fetching users")
      }
      set({
        users: data,
        paginationUsers: pagination,
      })
    } catch (error: any) {
      toast.error(error?.message || "Error fetching users")
    } finally {
      set({ loading: null })
    }
  },
  onChangeUserQueryParams: (key: keyof UsersTypes.IQueryParams, value: any) => {
    const { getUsers, userQueryParams } = get()
    const newPage = key !== "page" ? 1 : value
    set({ userQueryParams: { ...userQueryParams, [key]: value, page: newPage } })
    getUsers({ page: newPage })
  },
  resetUsers: () => {
    set({ ...initState })
  },
})
